// extracted by mini-css-extract-plugin
module.exports = {"root":"toxic-waste-disposal-page_root__HF_li"};